module.exports = __webpack_public_path__ + "img/banner-principal.22b5bff5.png";